module.exports = __webpack_public_path__ + "d26bd6f5466452b2b72912da964aa34d.pdf";